import ReactDOM from 'react-dom';
import StandaloneModule from './modules/Standalone/StandaloneModule';
import UnsupportedBrowser from './UnsupportedBrowser';

/**
 * 1. Render the unsupported browser message inside the `app` container to
 *    keep it compatible with external banners like Intercom
 * 2. We must assume App could crash, then the UnsupportedBrowser should be
 *    rendered separately
 *
 * @todo wrap app in <React.StrictMode> https://reactjs.org/docs/strict-mode.html
 */
ReactDOM.render(
  <>
    <UnsupportedBrowser />
    <StandaloneModule />
  </>,
  document.getElementById('app')
);
